import { render, staticRenderFns } from "./FormAddNewCard.vue?vue&type=template&id=2413d8c6&scoped=true&"
import script from "./FormAddNewCard.vue?vue&type=script&lang=js&"
export * from "./FormAddNewCard.vue?vue&type=script&lang=js&"
import style0 from "./FormAddNewCard.vue?vue&type=style&index=0&id=2413d8c6&prod&lang=scss&"
import style1 from "./FormAddNewCard.vue?vue&type=style&index=1&id=2413d8c6&prod&lang=scss&scoped=true&"
import style2 from "./FormAddNewCard.vue?vue&type=style&index=2&id=2413d8c6&prod&lang=scss&"
import style3 from "./FormAddNewCard.vue?vue&type=style&index=3&id=2413d8c6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2413d8c6",
  null
  
)

export default component.exports